<template>
  <div>
    <div class="detail_top">
      <img class="detail_cover" :src="$global.imgUrl + detailImg[0]" alt="" />
      <div class="detail_title_box">
        <h1 class="detail_title">{{ detailTitle }}</h1>
        <p v-show="!isClose">当前推广已关闭</p>
      </div>
    </div>
    <div class="detail_list_box">
      <div class="detail_list_top">
        <span>累计佣金：¥{{ commission }}</span>
        <span>成单数量：{{ nums }}</span>
      </div>
      <van-list v-if="list.length > 0" v-model="loading" :finished="finished" :immediate-check="false"
        finished-text="没有更多了" @load="onLoad">
        <van-cell class="list_item" v-for="item in list" :key="item.id">
          <div class="item_div">
            <span class="item_amount">佣金：{{ item.type === 1 ? '+' : '-' }}¥{{ item.promoterAmount }}</span>
            <span class="item_type">{{
              item.type === 1 ? "交易成功" : "交易取消"
            }}</span>
          </div>
          <p class="item_p">订单编号：{{ item.orderId }}</p>
          <p class="item_p">下单时间：{{ item.orderTime }}</p>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailImg: [],
      detailTitle: "",
      nums: 0,
      commission: 0,
      loading: false,
      finished: false,
      isClose: true,
      list: [],
      params: {
        pageNum: 1,
        pageSize: 10,
        promoterId: "",
        goodsId: 0,
      },
    };
  },
  created() {
    this.params.promoterId = JSON.parse(
      sessionStorage.getItem("userInfo")
    ).promoterId;
    this.params.goodsId = this.$route.query.goodsId;
    this.nums = this.$route.query.nums;
    this.commission = this.$route.query.commission;
    this.getList();
  },
  methods: {
    onLoad() {
      console.log(222);
    },
    async getList() {
      this.loading = true;
      let obj = this.$global.deepClone(this.params);
      const res = await this.$apis.extendServe.getExtendDetail(obj);
      if (res.resultCode === "200") {
        this.detailImg = res.content.goods.albumPics.split(",");
        this.detailTitle = res.content.goods.goodsName;
        this.list.push(...res.content.data.list);
        this.finished = this.list.length >= +res.content.data.total;
        this.isClose = res.content.isClose;
        console.log(this.finished);
      } else {
        this.finished = true;
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.detail_top {
  display: flex;
  padding: 13px 12px;
  background-color: #fff;

  .detail_cover {
    width: 80px;
    height: 80px;
    border-radius: 6px;
  }

  .detail_title_box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    margin-left: 10px;

    .detail_title {
      font-size: 15px;
      color: #333333;
      line-height: 23px;
    }

    p {
      font-size: 12px;
      color: #999999;
    }
  }
}

.detail_list_box {
  margin: 12px auto;
  padding-bottom: 19px;
  width: 351px;
  background-color: #fff;
  border-radius: 8px;

  .detail_list_top {
    display: flex;
    justify-content: space-between;
    padding: 0 12px;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #eeeeee;
    font-size: 13px;
    color: #666666;
  }

  .list_item {
    padding: 15px 12px;

    .item_div {
      display: flex;
      justify-content: space-between;
      margin-bottom: 14px;

      .item_amount {
        font-size: 15px;
        color: #333333;
      }

      .item_type {
        font-size: 13px;
        color: #ff3d3d;
      }
    }

    .item_p {
      margin-top: 9px;
      font-size: 13px;
      color: #999999;
      line-height: 19px;
    }
  }
}
</style>